import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedConstants } from '@app/eds';

export interface IChipToggleData {
  chipTextKey: string;
  chipIconName?: string;
  showIcon?: boolean;
  chipIconSize?: string;
  chipName?: string;
  id: number;
}

@Component({
  selector: 'app-chip-toggler',
  templateUrl: './chip-toggler.component.html',
  styleUrls: ['./chip-toggler.component.scss']
})
export class ChipTogglerComponent implements OnInit {
  // Text to show on top of toggler
  @Input() headingText: string = SharedConstants.EMPTY_STRING;

  // List of chip data, should be only of length 2
  @Input() chipData: IChipToggleData[] = [];

  // Tracks which chip is currently active
  @Input() activeChip: IChipToggleData = {} as IChipToggleData;

  // Whether to disable the toggler or not
  @Input() disableChipToggler = false;

  // Height of the chip.
  @Input() height!: string;

  // To specify if the chip-toggler is a tab-switcher.
  // Affects the styling of the toggler.
  @Input() isTabSwitcher = false;

  // A property contains class names of chips to apply common styles
  @Input() public chipContentClassNames!: string | string[];

  // Custom class for the chip.
  customClass!: object;

  // Event emitter when chip is toggled
  @Output() chipToggledEvent: EventEmitter<IChipToggleData> =
    new EventEmitter<IChipToggleData>();

  ngOnInit() {
    this.setCustomClass();
  }

  /**
   * This function sets the custom class for the chip.
   * Sets the height as specified by the parent component.
   */
  setCustomClass = () => (this.customClass = { height: this.height });

  /**
   * Event emitter with the selected chip data only
   * when the chip toggler is not disabled
   *
   * @param {number} chipId which chip is clicked on
   */
  onChipClickHandler = (chipId: number) => {
    if (!this.disableChipToggler) {
      this.activeChip =
        this.chipData.find((chip) => chip.id === chipId) || ({} as IChipToggleData);
    }
    this.chipToggledEvent.emit(this.activeChip);
  };

  /**
   * Checks whether the chip is active or not
   *
   * @param {number} chipId which chip is clicked on
   * @returns {boolean} active or not
   */
  isChipActive = (chipId: number) => this.activeChip?.id === chipId;
}
